module.exports = __webpack_public_path__ + "img/编组 61.83e3cfaa.png";